/**
 * Number text for formulas and working: a typographic minus (U+2212) instead of the
 * hyphen-minus `Intl.NumberFormat` writes, so −30 lines up with the − operators around it.
 * Pass the result of the widget's own formatter, so decimal marks stay locale-correct.
 */
const LEADING_HYPHEN = /^-/;

export function minus(formatted: string): string {
  return formatted.replace(LEADING_HYPHEN, "−");
}
